<template>
  <div class="editor mb-14">
    <div id="vue-editor-js">
      <div id="codex-editor" class="article-post"></div>
    </div>
  </div>
</template>

<script>
  import EditorJS from './editorjs'
  import Header from './editorjs/header'
  import Table from './editorjs/table'
  import Embed from './editorjs/embed'
  import {
    BlockHr,
    TextGrid,
    Unsplash,
    ImageSlider,
    ImageGrid,
    Snippet,
    Callout,
    Quote,
    UpsideIndex,
    DownIndex,
    Colorizer,
    List
  } from './customBlocks'

  import { updateEditorConfig } from './editorConfig'

  export default {
    name: 'create-article',
    props: {
      value: {
        type: [String, Object],
        default: null,
      },
      customComponents: {
        type: Object,
        default: () => ({})
      },
      imgUploadURL: {
        type: String,
        default: ''
      }
    },
    created () {
      updateEditorConfig({
        imgUploadURL: this.imgUploadURL
      })
    },
    mounted () {
      window.$toast = this.$toast
      this.initEditor()
    },
    beforeDestroy () {
      this.textEditor.destroy()
    },
    methods: {
      initEditor () {
        this.textEditor = new EditorJS({
          holder: 'codex-editor',
          data:
            typeof this.value === 'string'
              ? JSON.parse(this.value)
              : this.value,
          tools: {
            header: {
              class: Header,
              inlineToolbar: true,
              title: 'Заголовок',
              config: {
                levels: [2, 3, 4, 5, 6],
                defaultLevel: 3
              }
            },
            list: {
              class: List,
              inlineToolbar: true,
              title: 'Список',
            },
            table: {
              class: Table,
              title: 'Таблица',
            },
            embed: {
              class: Embed,
              config: {
                services: {
                  youtube: true,
                  coub: true,
                  vimeo: {
                    regex: /^.*(vimeo\.com\/)([0-9]+)/,
                    embedUrl: 'https://player.<%= remote_id %>',
                    html:
                      '<iframe width=\'100%\' height=\'315\' frameborder=\'0\' allow=\'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\' allowfullscreen></iframe>',
                    id: groups => groups.join('video/'),
                  },
                },
              },
            },
            Unsplash,
            BlockHr,
            TextGrid: {
              class: TextGrid,
              inlineToolbar: true,
            },
            ImageGrid,
            ImageSlider,
            DownIndex,
            UpsideIndex,
            Colorizer,
            Callout,
            Quote,
            Snippet,
            ...this.customComponents
          },
          onChange: () => { this.saveEditorData() },
          logLevel: 'ERROR'
        })
      },
      saveEditorData () {
        this.textEditor
          .save()
          .then(outputData => {
            this.$emit('input', outputData)
          })
          .catch(error => {
            console.error('Saving failed: ', error)
          })
      },
    },
  }
</script>

<style lang="scss" type="text/scss">
.btn-redactor {
  display : flex;
  align-items : center;
  *:not(:last-child) {
    margin-right : 6px;
  }
}
.article-post h1 {
  font-size   : 50px;
  font-weight : bold;
}

.article-post h2 {
  font-size   : 42px;
  font-weight : bold;
}

.article-post h3 {
  font-size   : 32px;
  font-weight : bold;
}

.article-post h4 {
  font-size   : 24px;
  font-weight : bold;
}

.article-post h5 {
  font-size   : 18px;
  font-weight : bold;
}

.article-post h6 {
  font-size   : 16px;
  font-weight : bold;
}

input[type=radio] + label::before {
  flex : unset;
}

.ce-toolbox__button:hover {
  color : $primary-color;
}

.ce-toolbar__plus:hover {
  color : $primary-color;
}

.editor {
  padding       : 7px 12px;
  border-radius : 5px;
  border        : 1px solid rgba(77, 77, 77, 0.25);
}

.codex-editor svg {
  width  : auto;
  height : auto;
}

.tc-toolbar {
  background : $primary-color;
}

.tc-toolbar__plus svg circle {
  fill : $primary-color !important;
}

.create-article-grid {
  display               : grid;
  grid-template-columns : 1fr 1fr 1fr;
  grid-gap              : 20px;
  align-items           : center;
}

.create-article-grid_announcement {
  grid-column : 1 / 4;
}

.create-article-grid_save-button {
  grid-column : 3 / 4;
}

#vue-editor-js {
  grid-column : 1 / 4;
}

.text-grid {
  width       : 100%;
  display     : flex;
  align-items : flex-start;
  flex-wrap   : wrap;
}

.text-grid_wrap {
  display : flex;
  flex-wrap: nowrap;
  width         : 100%;
  margin-bottom : 14px;
}

.text-grid_column {
  padding : 5px;
}

.text-grid_textarea {
  background: #f7f7f7;
  border-radius: 10px;
  padding: 8px 14px;
  min-height : 100px;
}

.text-grid_select {
  padding          : 7px;
  width            : 207px;
  height           : 34px;
  margin-right     : 14px;
  border-radius    : 5px;
  background-color : #f7f7f7;
}

.text-grid_button {
  justify-self : end;
}

.text-grid--end {
  align-items     : flex-start;
  justify-content : flex-end;
}

.text-grid--6-6 {
  display               : grid;
  grid-template-columns : 1fr 1fr;
  grid-gap              : 20px;
  outline               : none;
}

.text-grid--4-4-4 {
  display               : grid;
  grid-template-columns : 1fr 1fr 1fr;
  grid-gap              : 20px;
}

.text-grid--3-3-3-3 {
  display               : grid;
  grid-template-columns : 1fr 1fr 1fr 1fr;
  grid-gap              : 20px;
}

.text-grid--8-4 {
  display               : grid;
  grid-template-columns : 2fr 1fr;
  grid-gap              : 20px;
}

.text-grid--4-8 {
  display               : grid;
  grid-template-columns : 1fr 2fr;
  grid-gap              : 20px;
}

.text-grid--6-3-3 {
  display               : grid;
  grid-template-columns : 2fr 1fr 1fr;
  grid-gap              : 20px;
}

.text-grid--3-3-6 {
  display               : grid;
  grid-template-columns : 1fr 1fr 2fr;
  grid-gap              : 20px;
}

.text-grid--2-8-2 {
  display               : grid;
  grid-template-columns : 1fr 4fr 1fr;
  grid-gap              : 20px;
}

.image-grid {
  width         : 100%;
  display       : flex;
  overflow      : hidden;
  align-items   : center;
  padding-top    : 32px;
  padding-bottom : 60px;
}

.image-grid img {
  object-fit : cover;
  width      : 100%;
}

.image-grid_input-wrapper {
  position : relative;
}

.form {
  max-width : 100%;
  label {
    display : flex;
    flex-direction: column;
  }
  input {
    border: 1px solid #e4e4e4;
  }
}

.image-grid--double {
  display               : grid;
  grid-template-columns : 1fr 1fr;
  grid-gap              : 20px;
  align-items           : center;
}

.image-grid--triple {
  display               : grid;
  grid-template-columns : 1fr 1fr 1fr;
  grid-gap              : 20px;
  align-items           : center;
}

.slider_wrap {
  @extend .image-grid;
  &--edit {
    padding-bottom : 80px;
  }
}

.slider_list {
  width           : 100%;
  position        : relative;
  left            : 0;
  top             : 0;
  list-style-type : none;
  display         : flex;
  align-items     : center;
  transition      : left 0.4s;
  height          : 400px;
  max-height      : 40vh;
  margin : 0 !important;
}

.slider_list li {
  width       : 100%;
  height      : 100%;
  flex-shrink : 0;
}

.slider_list li img {
  object-fit : contain;
  height     : 100%;
  width      : 100%;
}

.slider_switch {
  cursor    : pointer;
  top       : 50%;
  transform : translateY(-50%);
  width     : 20px;
  height    : 20px;
}

.slider_switch--left {
  border-left : 2px solid #afafaf;
  border-top  : 2px solid #afafaf;
  transform   : rotate(-45deg);
  position    : absolute;
  left        : -40px;
  transition  : border 0.4s;
}

.slider_switch--left:hover {
  border-left : 2px solid $primary-color;
  border-top  : 2px solid $primary-color;
  transition  : border 0.4s;
}

.slider_switch--right {
  border-right : 2px solid #afafaf;
  border-top   : 2px solid #afafaf;
  transform    : rotate(45deg);
  position     : absolute;
  right        : -40px;
  transition   : border 0.4s;
}

.slider_switch--right:hover {
  border-right : 2px solid $primary-color;
  border-top   : 2px solid $primary-color;
  transition   : border 0.4s;
}

.snippet {
  display        : flex;
  flex-direction : column;
  margin-bottom : 24px;
}
.snippet_header {
  margin-bottom : 14px;
}
.snippet_input {
  width      : 100%;
  min-height : 150px;
  border     : 0.5px solid #afafaf;
  padding    : 7px;
  // min-height: 150px;
  &-text {
    padding    : 4px 7px;
    border     : 0.5px solid #afafaf;
    margin-bottom : 8px;
  }
}

.snippet_button {
  margin-top : 14px;
  align-self : flex-end;
}

.snippet_switcher {
  position         : relative;
  padding          : 14px;
  background-color : #f6f6f6 !important;
  font-size        : 18px;
  border-radius    : 5px;
  cursor           : pointer;

  &:before {
    content          : '';
    position         : absolute;
    left             : 0;
    top              : 50%;
    transform        : translateY(-50%);
    width            : 18px;
    height           : 18px;
    background-image : url('/dist/assets/front_white/img/arrow-up.svg');
    background-size  : 100%;
  }
}

.snippet_content {
  background-color : #f6f6f6 !important;
  font-size        : 14px;
  overflow         : hidden;
  // height: 0;
  // max-height: 0;
  display          : none;
  transition       : max-height 0.3s;
}

.snippet--active {
  .snippet_switcher {
    border-bottom-right-radius : 0;
    border-bottom-left-radius  : 0
  }

  .snippet_content {
    // max-height: 2000px;
    padding                    : 0 14px 14px;
    // height: auto;
    display                    : block;
    transition                 : max-height 1s;
    border-bottom-right-radius : 5px;
    border-bottom-left-radius  : 5px;
  }

  .snippet_switcher {
    &:before {
      transform : rotate(180deg) translateY(50%);
    }
  }
}

.callout {
  // padding-left: 30px;
  display        : flex;
  flex-direction : column;
}

.callout--mounted {
  padding-left : 30px;
}

#radio_notice {
  margin-left : 10px;
}

.radio-wrap {
  padding: 14px 0;
}

.radio_label {
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.radio_label:not(:last-child) {
  margin-bottom: 14px;
}

#radio_interesting {
  margin-left : 10px;
}

.callout_submit {
  margin-top      : 10px;
  display         : flex;
  justify-content : flex-end;
}

.callout_input {
  margin-top : 10px;
}

.callout_title {
  margin-top    : 0;
  margin-bottom : 8px;
}

.callout--attention {
  border-left : 4px solid $primary-color;
}

.callout--attention .callout_title {
  color : $primary-color;
}

.callout--notice {
  border-left : 4px solid $primary-color;
}

.callout--notice .callout_title {
  color : $primary-color;
}

.callout--interesting {
  border-left : 4px solid $primary-color;
}

.callout--interesting .callout_title {
  color : $primary-color;
}

.quote {
  display        : flex;
  flex-direction : column;
  overflow       : hidden;
}

.quote_paragraph {
  font-size     : 22px;
  margin-bottom : 0;
}

.quote_title {
  text-align    : right;
  margin-top    : 10px;
  margin-bottom : 0;
}

.quote_subtitle {
  text-align    : right;
  margin-top    : 10px;
  margin-bottom : 0;
}

.unsplash {
  padding   : 14px 0;
  display   : flex;
  flex-wrap : wrap;
}

.unsplash-grid {
  margin-top            : 14px;
  padding-bottom        : 4px;
  display               : grid;
  grid-template-columns : 1fr 1fr;
  grid-gap              : 14px;
  border-bottom         : 1px solid #afafaf;

  img {
    cursor : pointer;
  }
}

.unsplash-grid--passed {
  display         : flex;
  justify-content : center;

  img {
    cursor     : unset;
    max-width  : 100%;
    object-fit : contain;
  }
}

.unsplash_header {
  width : 100%;

}

.unsplash_input {
  width         : 200px;
  height        : 26px;
  outline       : none;
  margin-top    : 14px;
  display       : flex;
  align-items   : center;
  border-bottom : solid 1.5px #afafaf;
}

[contentEditable=true]:empty:not(:focus):before {
  content : attr(data-text);
  color   : #b2b2b2;
}

.unsplash_button {
  outline       : none;
  cursor        : pointer;
  margin-top    : 14px;
  margin-left   : 14px;
  border-radius : 5px;
  border        : none;
  background    : transparent;
}

.preloader::after {
  position            : relative;
  // top: 0;
  // bottom: 4%;
  // right: 0;
  // left: 0;

  content       : " ";
  display       : block;

  margin        : auto;
  height        : 24px;
  width         : 24px;

  box-sizing    : border-box;
  border-radius : 50%;
  border        : 4px solid rgba(140, 140, 140, 0.2);
  border-top-color : rgba(140, 140, 140, 0.55);

  animation     : rotating 0.9s linear infinite;
}

@keyframes rotating {
  from {
    transform : rotate(0deg);
  }
  to {
    transform : rotate(360deg);
  }
}

.ce-block--selected .ce-block__content {
  background: #e5f7f5;
}
.cdx-settings-button--active {
  color: $primary-color;
}

.colorizer {
	background-color: transparent;
}
</style>
